import { render } from "./ButtonWithIcon.vue?vue&type=template&id=9fd4dc5e&scoped=true"
import script from "./ButtonWithIcon.vue?vue&type=script&lang=js"
export * from "./ButtonWithIcon.vue?vue&type=script&lang=js"

import "./ButtonWithIcon.vue?vue&type=style&index=0&id=9fd4dc5e&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fd4dc5e"]])

export default __exports__